export interface DataFlow {
    source: string,
    target: string,
    value: number,
}

export function flowsAreEqual(fisrtFlow: DataFlow, otherFlow: DataFlow): Boolean {
    return fisrtFlow.source == otherFlow.source && fisrtFlow.target == otherFlow.target
}
